import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { computed, toRefs } from 'vue'
import { LinkType } from 'frontcore/views/link/types'
import { RouteLocationRaw } from 'vue-router'

interface Props {
  linkText: string
  to: RouteLocationRaw
  dataTest?: string
  linkType?: LinkType
  isExternal?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CoreLink',
  props: {
    linkText: {},
    to: {},
    dataTest: { default: 'core-link' },
    linkType: { default: LinkType.PRIMARY },
    isExternal: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const {
  linkText,
  to,
  dataTest,
  isExternal,
} = toRefs(props)

const component = computed(() => {
  return isExternal?.value ? 'a' : 'router-link'
})

const extraComponentProps = computed(() => {
  const _extraComponentProps: {
    href?: string,
  } = {}

  if (isExternal.value) {
    _extraComponentProps.href = to.value.toString()
  }

  return _extraComponentProps
})

const target = computed(() => {
  return isExternal?.value ? '_blank' : ''
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), _mergeProps(extraComponentProps.value, {
    class: ["tw-inline body--body-01", {
      'link-primary': _ctx.linkType === _unref(LinkType).PRIMARY,
      'link-ghost': _ctx.linkType === _unref(LinkType).GHOST
    }],
    "data-test": _unref(dataTest),
    target: target.value,
    to: _unref(to)
  }), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(linkText)) + " ", 1),
      (_unref(isExternal))
        ? (_openBlock(), _createBlock(SVGIcon, {
            key: 0,
            colorClass: "tw-inline tw-mb-1",
            iconName: "OpenInNew",
            "data-test": _unref(dataTest) + '-external-icon',
            remSize: 1.0
          }, null, 8, ["data-test"]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }, 16, ["class", "data-test", "target", "to"]))
}
}

})